enum general {
    'cancel' = 'Cancel',
    'clean' = 'Clean',
    'collapse_all' = 'Collapse all',
    'confirm' = 'Confirm',
    'danger' = 'Danger',
    'detail' = 'Detail',
    'error' = 'Error',
    'expand_all' = 'Expand all',
    'extension' = 'Extension',
    'file' = 'File',
    'filename' = 'Filename',
    'files' = 'Files',
    'folder' = 'Folder',
    'folders' = 'Folders',
    'import' = 'Import',
    'info' = 'Info',
    'loading' = 'Loading',
    'name' = 'Name',
    'ok' = 'Ok',
    'open' = 'Open',
    'open_as' = 'Open as',
    'server' = 'Server',
    'size' = 'Size',
    'success' = 'Success',
    'time' = 'Time',
    'url' = 'URL',
    'warning' = 'Warning',
}

export default general;
